import React, { FunctionComponent } from "react"
import { Table } from "react-bootstrap"
import HRRReportsTableHeader from "./HRRReportsTableHeader/HRRReportsTableHeader"
import HRRReportsTableBody from "./HRRReportsTableBody/HRRReportsTableBody"
import "./HRRReportsTable.css"


const HRRReportsTable: FunctionComponent<{}> = () => {
    return (
        <div className="HRRReportsTable">
            <Table id="hr-reports-table" bordered>
                <HRRReportsTableHeader />
                <HRRReportsTableBody />
            </Table>
        </div>
    )
}

export default HRRReportsTable